module.exports = __webpack_public_path__ + "media/images/Ad_300x250-aa7a92ece2d0e38eee118fde38d68b9c.png";